import * as t from 'io-ts'
import { either } from 'fp-ts/lib/Either'
export interface JsonFromStringC extends t.Type<unknown, string, unknown> {}

export const JsonFromString: JsonFromStringC = new t.Type<
  unknown,
  string,
  unknown
>(
  'JsonFromString',
  t.unknown.is,
  (u, c) =>
    either.chain(t.string.validate(u, c), (s) => {
      try {
        return t.success(JSON.parse(s))
      } catch (e:any) {
        return t.failure(u, c, e.message)
      }
    }),
  JSON.stringify,
)
